"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlParams = exports.getLastParam = void 0;
var getLastParam = function () {
    var splitted = window.location.pathname.split('/');
    return splitted[splitted.length - 1];
};
exports.getLastParam = getLastParam;
var getUrlParams = function (url, param) {
    var e_1, _a;
    if (param === void 0) { param = null; }
    var _url = new URL(url);
    if (_url.search === '')
        return null;
    var searchParams = new URLSearchParams(_url.search);
    if (param)
        return searchParams.get(param);
    var params = {};
    try {
        // @ts-ignore
        for (var _b = __values(searchParams.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var entry = _c.value;
            params[entry[0]] = entry[1].split(',');
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return params;
};
exports.getUrlParams = getUrlParams;
